import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams, SerializedNumberFilter } from 'ag-grid';

@Component({
    template: `` // PershingNumberFilterComponent will not be used by itself so no need to define a template at the moment
})
export class PershingNumberFilterComponent implements IFilterAngularComp {
    params: IFilterParams;
    filterModel: PershingNumberFilter;

    agInit(params: IFilterParams) {
        this.params = params;
    }

    isFilterActive(): boolean {
        return false;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        return false;
    }

    getModel(): PershingNumberFilter {
        return this.filterModel ? this.filterModel : null;
    }

    setModel(model: PershingNumberFilter) {
        this.filterModel = model;
    }

    // Documentation on here https://www.ag-grid.com/javascript-grid-filter-component/
    onFloatingFilterChanged(event: any) {
        this.setModel(event.model);
        this.params.filterChangedCallback();
    }
}

export interface PershingNumberFilter extends SerializedNumberFilter {
    queryName: string;
}
